import { Injectable, inject } from '@angular/core';
import { CanActivate } from '@angular/router';
import { RouteGuardService } from './service/route-guard.service';
import { View } from '../layout/model/interfaces/view.interface';
import { SystemService } from '../shared/service/system/system.service';

@Injectable({ providedIn: 'root' })
export class OrganisationCreateViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);
  private systemService = inject(SystemService);


  async canActivate(): Promise<boolean> {
    const view = this.getView();
    if (view) {
      const shouldNavigate = await this.routeGuardService.handleRoute(view);
      return shouldNavigate;
    }
    return true;
  }
  getView(): View {
    return {
      route: `companies/new`,
      iframeUrl: `company/new`,
    };
  }
}
